<template>
  <v-card
    flat
    tile
  >
    <v-app-bar
      app
      clipped-left
      color="#eae1d8"
    >
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-btn
        text
        class="title ma-0 pa-0"
      >
        {{ site.title }}
      </v-btn>

      <v-spacer></v-spacer>

      <!-- <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-avatar size="32">
              <v-img :src="$store.state.fireUser.photoURL"></v-img>
            </v-avatar>
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            "{{ $store.state.fireUser.displayName }}" 님
          </v-card-title>
          <v-card-actions>
            <v-btn dark @click="signOut" block>로그아웃</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu> -->

      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-width="200"
        offset-x
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
          >
            <v-avatar size="32">
              <v-img
                v-if="userData.photo"
                :src="userData.photo"
              ></v-img>
              <v-icon
                v-else
                dark
              >
                mdi-account-circle
              </v-icon>
            </v-avatar>
          </v-btn>
        </template>
        <v-card>
          <v-list>
            <v-list-item>
              <v-list-item-avatar>
                <v-img :src="userData.photo"></v-img>
                <v-avatar size="32">
                  <v-img
                    v-if="userData.photo"
                    :src="userData.photo"
                  ></v-img>
                  <v-icon
                    v-else
                    dark
                  >
                    mdi-account-circle
                  </v-icon>
                </v-avatar>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>{{ userData.name }}</v-list-item-title>
                <v-list-item-subtitle>{{ userData.company }}</v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-btn
                  icon
                  to="/Members"
                  @click="menu = false"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>

          <v-divider></v-divider>

          <!-- <v-list>
            <v-list-item>
              <v-list-item-action>
                <v-switch
                  v-model="message"
                  color="purple"
                ></v-switch>
              </v-list-item-action>
              <v-list-item-title>Enable messages</v-list-item-title>
            </v-list-item>

            <v-list-item>
              <v-list-item-action>
                <v-switch
                  v-model="hints"
                  color="purple"
                ></v-switch>
              </v-list-item-action>
              <v-list-item-title>Enable hints</v-list-item-title>
            </v-list-item>
          </v-list> -->

          <v-card-actions>
            <v-spacer></v-spacer>

            <!-- <v-btn
              text
              @click="menu = false"
            >
              Cancel
            </v-btn> -->
            <v-btn
              color="red darken-1"
              text
              @click="signOut"
            >
              로그아웃
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      app
      clipped
      color="grey lighten-4"
    >
      <v-list
        dense
        class="grey lighten-4"
      >
        <template v-for="(item, i) in site.items">
          <v-row
            v-if="item.heading"
            :key="i"
            align="center"
          >
            <v-col cols="6">
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-col>
            <v-col
              cols="6"
              class="text-right"
            >
            </v-col>
          </v-row>
          <v-divider
            v-else-if="item.divider"
            :key="i"
            dark
            class="my-0"
          ></v-divider>
          <v-list-item
            v-else
            :key="i"
            link
            :to="item.to"
          >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="grey--text">
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    menu: false,
    dialog: false,
    drawer: null,
    User: null,
    userData: [],
    site: {
      title: '',
      items: []
    }
  }),

  created () {
    this.subscribe()
  },

  updated () {
  },

  mounted () {
  },

  methods: {
    subscribe () {
      var userID = this.$firebase.auth().currentUser.uid
      var _this = this

      if (userID) {
        this.$firebase.database().ref().child('site').on('value', (sn) => {
          const v = sn.val()
          if (!v) {
            this.$firebase.database().ref().child('site').set(this.site)
          }
          this.site = v
        }, (e) => {
          console.log(e.message)
        })

        this.$firebase.database().ref('users/' + userID).once('value').then(function (snapshot) {
          if (snapshot.empty) {
            return
          }

          _this.userData.name = (snapshot.val() && snapshot.val().displayName) || '승인중'
          _this.userData.company = (snapshot.val() && snapshot.val().company) || ''
          _this.userData.photo = (snapshot.val() && snapshot.val().photoURL) || ''
          _this.userData.license = (snapshot.val() && snapshot.val().license) || ''
        })
      }
    },

    link: function (path) {
      this.$router.push(path)
    },

    signOut () {
      var _this = this

      _this.menu = false

      _this.$firebase.auth().signOut().then(
        function () {
          _this.link('login')
        }
      )
    }

    // save () {
    //   this.$firebase.database().ref().child('abcd').set({
    //     title: 'title',
    //     text: 'text'
    //   })
    // },

    // read () {
    //   this.$firebase.database().ref().child('abcd').on('value', (sn) => {
    //     console.log(sn)
    //     console.log(sn.val())
    //   })
    // },

    // async readOne () {
    //   const sn = await this.$firebase.database().ref().child('abcd').once('value')
    //   console.log(sn.val())
    // }
  }
}
</script>
